// extracted by mini-css-extract-plugin
export var form = "_50-0";